<div class="row zeromarginRow">
  <div
    class="col-12 col-md-6 zeroPaddingColumn"
    [ngClass]="{'fullWidthBoxes': fullWidth, 'max10Items': max10Items, 'withPrimary': withPrimary}"
    >
    <div class="row zeromarginRow">
      <div class="col-6 zeroPaddingColumn">
        <h2 class="listboxTitle listboxTitle_left">Available {{title}}(s)</h2>
        <input
          type="text"
          [disabled]="disabled"
          [(ngModel)]="filter1"
          class="k-textbox fullwidthListboxInputSearch"
          [ngClass]="showFilters ? 'showFilters' : ''"
          placeholder="Search for available item"
          />
          <div
            class="bordered_sections_special_small_listbox bordered_sections_special_left select-box leftListbox"
            [ngClass]="{'minHeightSection': !max10Items}"
            >
            <div class="buttonsAbsolutecontainer_left">
              <img
                class=""
                (click)="moveSelected('right')"
                [src]="'/assets/menu/'+ _theme +'/move-right-arrow.svg'"
                />
                <img
                  class=""
                  (click)="moveAll('right')"
                  [src]="'/assets/menu/'+ _theme +'/move-all-right-arrow.svg'"
                  />
                </div>
                <div class="row">
                  <div class="col-12">
                    <div >



                      <ul class="selectedFieldsArray">
                        @for (group of _groupedDataFields; track group) {
                          <li >
                            <div   style="background-color: #d3d3d399;">
                              <span style="margin-left: 3%">  {{group.value}}</span>
                            </div>
                            <ul style="margin-left: 1%;">
                              @for (field of readFilteredFieldsGrouped(1, group.items); track field; let i = $index) {
                                <li style="margin-left:-5%"
                                  (click)="toggleSelection($event,field)"
                                  [class.item-selected]="field.isSelected"
                                  >
                                  <!-- <li style="margin-left:-10%"
                                  *ngFor="let field of group.items; index as i;"
                                  (click)="toggleSelection($event,field)"
                                  [class.item-selected]="field.isSelected"
                                  > -->
                                  <span>{{field[displayFieldName]}}</span>
                                </li>
                              }
                            </ul>
                          </li>
                        }

                      </ul>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="col-6 zeroPaddingColumn">
              <h2 class="listboxTitle listboxTitle_right">Selected {{title}}(s)</h2>
              <input
                type="text"
                [disabled]="disabled"
                class="k-textbox fullwidthListboxInputSearch fullwidthListboxInputSearch_right"
                [ngClass]="showFilters ? 'showFilters' : ''"
                placeholder="Search for selected item"
                [(ngModel)]="filter2"
                />
                <div
                  class="bordered_sections_special_small_listbox select-box rightListbox"
                  [ngClass]="{'minHeightSection': !max10Items}"
                  >
                  <div
                    class="buttonsAbsolutecontainer_right"
                    [class.disabled]="!selectedFieldsCopy || selectedFieldsCopy.length == 0"
                    >
                    <img
                      (click)="moveSelected('left')"
                      [src]="'/assets/menu/'+ _theme +'/move-left-arrow.svg'"
                      />
                      <img
                        (click)="moveAll('left')"
                        [src]="'/assets/menu/'+ _theme +'/move-all-left-arrow.svg'"
                        />
                        <img [class.disabled]="FromBarcodeEditLabel"
                          (click)="verticalMove('down')"
                          [src]="'/assets/menu/'+ _theme +'/arrown-down.svg'"
                          />
                          <img [class.disabled]="FromBarcodeEditLabel"
                            (click)="verticalMove('up')"
                            [src]="'/assets/menu/'+ _theme +'/arrown-up.svg'"
                            />
                          </div>
                          <div class="row">
                            @if (withPrimary) {
                              <div class="col-12">
                                <span class="primary-title">Set As Primary</span>
                              </div>
                            }

                            <div class="col-12">
                              <ul class="selectedFieldsArray">
                                @for (field of readFilteredFields(2); track field; let i = $index) {
                                  <li
                                    (click)="toggleSelection($event,field)"
                                    [class.item-selected]="field.isSelected"
                                    >
                                    @if (withCustomCheckBox) {
                                      <input
                                        [disabled]="disabled"
                                        [checked]="field.isCustomChecBoxChecked"
                                        (click)="onCustomCheckBoxClick($event, field)"
                                        class="k-checkbox custom-checkbox"
                                        type="checkbox"
                                        #customCheckBoxes
                                        kendoCheckBox
                                        />
                                    }
                                    <span>{{field[displayFieldName]}}</span>
                                    @if (withPrimary) {
                                      <input
                                        [disabled]="disabled"
                                        [checked]="primaryField?.id == field.id"
                                        (click)="onPrimaryClick($event, field)"
                                        class="k-checkbox primary-check"
                                        type="checkbox"
                                        #primaryCheck
                                        kendoCheckBox
                                        />
                                    }
                                  </li>
                                }
                                <!-- <li  *ngFor="let group of _groupedDataSelectedFields">
                                <div   style="background-color: #d3d3d399;">
                                  <span style="margin-left: 3%">  {{group.value}}</span>
                                </div>
                                <ul>
                                  <li style="margin-left:-5%"
                                    *ngFor="let field of readFilteredFieldsGrouped(2, group.items); index as i;"
                                    (click)="toggleSelection($event,field)"
                                    [class.item-selected]="field.isSelected"
                                    >

                                    <span>{{field[displayFieldName]}}</span>
                                    <input
                                      *ngIf="withPrimary"
                                      [disabled]="disabled"
                                      [checked]="primaryField?.id == field.id"
                                      (click)="onPrimaryClick($event, field)"
                                      class="k-checkbox primary-check"
                                      type="checkbox"
                                      #primaryCheck
                                      kendoCheckBox
                                      />
                                    </li>
                                  </ul>

                                </li> -->
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
